import { withTranslation } from "react-i18next";

import EmailTemplateList from './EmailTemplateList';

export default withTranslation(undefined, { withRef: true })(EmailTemplateList);